<template>
    <loading v-if="isLoading"></loading>
    <transition v-else name="fade">
        <section class="settings">
            <header class="overlay__header">
                <aside>
                    <span>Account Settings</span>
                </aside>
            </header>
            <section class="panel">
                <aside class="panel__sidebar">
                    <nav data-locator="navigation" class="panel-navigation">
                        <router-link v-for="(route, index) in $router.options.routes"
                                     :key="index"
                                     :to="route.path"
                                     :exact="route.children === undefined"
                                     active-class="active"
                                     class="panel-navigation__item"
                                     role="tab">
                            {{ route.title }}
                        </router-link>
                    </nav>
                </aside>
                <div class="panel__content">
                    <portal-target slim name="panel_content"></portal-target>
                    <transition name="fade" mode="out-in" :duration="0">
                        <router-view :key="$route.path"></router-view>
                    </transition>
                </div>
            </section>
        </section>
    </transition>
</template>
<script>
/* global app */
import { mapState } from 'vuex'
import General from './General'
import ManageChannels from './Channels/ManageChannels'
import EmptyRouteView from '../Global/EmptyRouteView'
import PeopleIndex from './People/Index'
import PeopleOptions from './People/Options'
import PeopleInvite from './People/Invite'
import PeopleEdit from './People/Edit'
import Subscription from './Billing/Subscription'
import Invoices from './Billing/Invoices'
import { FETCH_ALL_CHANNELS } from '../../stores/global/actions'
import Loading from '../Global/Loading'
import VueRouter from 'vue-router'

const router = new VueRouter({
    mode: 'history',
    base: '/account/settings',
    routes: [
        { path: '/', component: General, title: 'General' },
        { path: '/channels', component: ManageChannels, title: 'Channels' },
        {
            path: '/people/',
            component: EmptyRouteView,
            title: 'People',
            children: [
                { path: '', title: 'People', component: PeopleIndex },
                { path: 'options', component: PeopleOptions },
                { path: 'invite-team-members', component: PeopleInvite, props: { role: 'team_member' } },
                { path: 'invite-multi-channel-guests', component: PeopleInvite, props: { role: 'multi_channel_guest' } },
                { path: 'invite-single-channel-guests', component: PeopleInvite, props: { role: 'single_channel_guest' } },
                { path: ':user/edit', component: PeopleEdit }
            ]
        },
        { path: '/subscriptions', component: Subscription, title: 'Subscription' },
        { path: '/invoices', component: Invoices, title: 'Invoices' },
        { path: '*', redirect: '/' }
    ]
})

export default {
    name: 'AccountSettings',

    router,

    data () {
        return {
            isLoading: true,
            enableSubstitutions: app.config.ENABLE_SUBSCRIPTIONS
        }
    },

    created () {
        Promise.all([
            this.$store.dispatch(FETCH_ALL_CHANNELS),
            this.$store.dispatch('tenant/fetchUsers')
        ]).then(() => {
            this.isLoading = false
            if (this.enableSubstitutions) {
                this.$store.dispatch('tenant/fetchInvoices')
            }
        })
    },

    computed: {
        ...mapState(['isActionConfirmationOpen'])
    },

    components: {
        Loading
    }
}
</script>
